import { Typography } from '@/components/atoms/Typography/Typography.styled';
import { medias } from '@/utils/sizes';
import { generateClampFromMinMax } from '@/utils/styling';
import styled from 'styled-components';

export const FormContainer = styled.div`
  --form-el-height: ${generateClampFromMinMax(55, 88)};

  position: relative;
  display: flex;
  flex-direction: column;
  width: ${generateClampFromMinMax(500, 700)} !important;
  padding: ${generateClampFromMinMax(40, 60)} !important;
  background-color: white;
  gap: var(--spacing-component-inner);
  margin-bottom: 8vh;

  .close-btn {
    position: absolute;
    top: var(--spacing-component-inner-sm);
    right: var(--spacing-component-inner-xs);
  }

  ${Typography}:not(span) {
    color: var(--c-black);
  }

  ${medias.max.mobile} {
    max-width: 500px;
    width: calc(100% - var(--page-pd-mobile-tablet) * 2);
  }

  p.text-error {
    color: rgb(230, 15, 15);
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-component-inner-sm);
  width: 100%;
`;

export const FormButton = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: var(--form-el-height);
  width: 100%;
  background-color: var(--c-black);
  color: var(--c-white);
  font-size: var(--fs-lg);
`;

export const LogOutConfirmation = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-component-inner-sm);

  button:first-of-type {
    background-color: transparent;
    border: 1px solid var(--c-black);
    color: var(--c-primary);
  }
`;
